import React from 'react';

function SocialItem({ href, imgSrc, imgClassName, imgAlt, handle }) {
  return (
    <div>
      <a href={href} target="_blank" rel="noreferrer">
        <img src={imgSrc} className={imgClassName} alt={imgAlt} />
        <p>{handle}</p>
      </a>
    </div>
  );
}

export default SocialItem;
